import React, { useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const NewMessageModal = ({ locals }) => {
  const { activeUser, activeSubscribersList: subscribers = [] } = locals;
  const { webAppTheme = "dark" } = activeUser;
  //store the filter value
  const [filterValue, setFilterValue] = useState("");
  //array of filtered users
  const filteredUsers = filterValue
    ? subscribers.filter((user) =>
        user.name.toLowerCase().startsWith(filterValue.toLowerCase())
      )
    : subscribers;

  /**
   * Go to that conversation, or create a new one and go to that one
   * @param {*} e
   * @param {*} id
   */
  const sendMessage = (e, id) => {
    e.preventDefault();
    submit(`/actions/user/check-chat-users/${id}/${true}`, {
      method: "POST",
      body: {},
    });
  };

  return (
    <Modal className="add-new-message-modal" title={"New message"}>
      <div className="body">
        <input
          placeholder={`Search athlete`}
          value={filterValue}
          onChange={({ target: { value } }) => setFilterValue(value)}
          type="search"
        />
        <div>
          <div className="edit-channel-cards-container">
            {filteredUsers.length === 0 && filterValue.length > 0 ? (
              <div className="empty-filter-chat-state">
                <p className="s1">No users with that name have been found</p>
              </div>
            ) : (
              filteredUsers.map((user) => {
                const { email = "", name = "", _id = "" } = user;
                return (
                  <button
                    className="edit-channel-cards"
                    key={_id}
                    onClick={(e) => {
                      sendMessage(e, _id);
                    }}
                  >
                    <div className="edit-channels-info-container">
                      <div
                        className={"avatar-group-chat"}
                        style={{
                          background: `url(${getAvatarUrl(
                            user,
                            false,
                            webAppTheme
                          )})`,
                          backgroundPosition: "center center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div className="identifier-group-chat">
                        <span className="name-group-chat">{name}</span>
                        <span className="role-group-chat">{email}</span>
                      </div>
                    </div>
                  </button>
                );
              })
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

NewMessageModal.propTypes = {
  locals: PropTypes.object,
};
